<template>
  <v-footer color="#D1DCEA" width="calc(100vw - 120px)" style="left: unset" fixed>
    <div class="flex-grow-1 d-flex align-center justify-space-between pr-4" style="max-width: calc(50% - 12px)">
      <v-tooltip :disabled="disabledButton || !disabledConciliacao" bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs">
            <v-btn
              @click="handleConciliarClick"
              :disabled="disabledButton || disabledConciliacao"
              color="primary"
            >
              Conciliar
            </v-btn>
          </div>
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
      <div>
        <v-row>
          <v-col>
            <b>{{ selectedPagamentoItensCount | pluralizePagamento }}</b>
          </v-col>
        </v-row>

        <v-row v-if="selectedPagamentoItensCount > 0" class="text-uppercase text-no-wrap">
          <v-col class="pt-0">
            <div>Total informado</div>
            <div><b>{{ totalInformadoPagamento | formatCurrency }}</b></div>
          </v-col>
          <v-col class="pt-0">
            <div>Total pago</div>
            <div class="success--text"><b>{{ totalPagoPagamento | formatCurrency }}</b></div>
          </v-col>
          <v-col class="pt-0">
            <div>Total glosado</div>
            <div class="red--text"><b>{{ totalGlosadoPagamento | formatCurrency }}</b></div>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-icon>
      fa-arrows-alt-h
    </v-icon>

    <div class="flex-grow-1 d-flex pl-4" style="max-width: calc(50% - 12px)">
      <div>
        <v-row>
          <v-col>
            <b>{{ selectedFaturamentoItensCount | pluralizeFaturamento }}</b>
          </v-col>
        </v-row>

        <v-row v-if="selectedFaturamentoItensCount > 0" class="text-uppercase text-no-wrap">
          <v-col class="pt-0">
            <div>Total informado</div>
            <div><b>{{ totalInformadoFaturamento | formatCurrency }}</b></div>
          </v-col>
          <v-col class="pt-0">
            <div>Total pago</div>
            <div class="success--text"><b>{{ totalPagoFaturamento | formatCurrency }}</b></div>
          </v-col>
          <v-col class="pt-0">
            <div>Total glosado</div>
            <div class="red--text"><b>{{ totalGlosadoFaturamento | formatCurrency }}</b></div>
          </v-col>
          <v-col class="pt-0">
            <div>Saldo</div>
            <div><b>{{ totalSaldoFaturamento | formatCurrency }}</b></div>
          </v-col>
        </v-row>
      </div>
    </div>
    <AlertDialog :open="alertIsOpen" :title="alertTitle" :description:="alertDescription" :errors="alertErrors" @close="closeModal"/>
  </v-footer>
</template>

<script>
import { ref } from 'vue'
import { mapGetters, mapState } from 'vuex'
import { conciliacaoClient, formatCurrency, sessionStorageClient } from '../../../libs'
import { pagamentoLoteStatusLabels } from '@tradimus/api-conciliacao-client'
import  AlertDialog  from '../../common/AlertDialog.vue'

export default {
  props: {
    param: { type: Boolean }
  },
  components: {
    AlertDialog
  },
  setup() {
      const alertIsOpen = ref(false);
      var isLoading = ref(false);
      const closeModal = () => {
        alertIsOpen.value = false
      };

      return { 
        alertIsOpen,
        isLoading,
        alertTitle: ref(''),
        alertDescription: ref(''),
        alertErrors: ref([]),
        closeModal
       }
  },
  computed: {
    ...mapState('conciliacao', ['selectedPagamentoItens', 'selectedFaturamentoItens']),
    ...mapGetters('conciliacao', [
      'pagamentoLoteStatus', 'pagamentoLoteResponsavel', 'isSelectedPagamentoItensRecurso', 'isSelectedPagamentoItensEstorno', 'hasSelectedPagamentoItemConciliado',
      'hasSelectedFaturamentoItemConciliado', 'selectedPagamentoItensCount', 'selectedFaturamentoItensCount']),
    isGlosaMaiorFaturado () {
      return false //this.totalGlosadoPagamento > this.totalInformadoFaturamento
    },
    disabledButton () {
      return this.selectedFaturamentoItensCount === 0 || this.selectedPagamentoItensCount === 0
    },
    isResponsavel () {
      const loggedUserId = Number(sessionStorageClient.getItem('userData')?.['Id'])
      return loggedUserId === Number(this.pagamentoLoteResponsavel?.id)
    },
    disabledConciliacao () {
      var permiteSegundaConcRegular = this.param && !this.isSelectedPagamentoItensRecurso
      console.log(permiteSegundaConcRegular)     
      
      return (
        this.pagamentoLoteStatus !== 'conciliacaoManual' ||
        this.hasSelectedPagamentoItemConciliado ||
        !this.isResponsavel ||
        this.isGlosaMaiorFaturado ||
        (permiteSegundaConcRegular && this.totalSaldoFaturamento <= 0 && (this.totalGlosadoPagamento + this.totalPagoPagamento) > 0 || permiteSegundaConcRegular && this.selectedFaturamentoItensCount > 1) ||
        //(permiteSegundaConcRegular && this.totalSaldoFaturamento > 0 && this.totalSaldoFaturamento  - this.totalPagoPagamento < 0) ||
        (!permiteSegundaConcRegular && this.hasSelectedFaturamentoItemConciliado && (!this.isSelectedPagamentoItensRecurso && !this.isSelectedPagamentoItensEstorno)) ||
        (!this.hasSelectedFaturamentoItemConciliado && this.isSelectedPagamentoItensEstorno)
      )
    },
    tooltipText () {
      if (this.hasSelectedPagamentoItemConciliado || (this.hasSelectedFaturamentoItemConciliado && (!this.isSelectedPagamentoItensRecurso && !this.isSelectedPagamentoItensEstorno))) {
        return 'Não é possível conciliar itens já conciliados.'
      } else if (!this.isResponsavel) {
        return 'Somente o responsável pelo lote pode realizar a conciliação.'
      } else if (!this.hasSelectedFaturamentoItemConciliado && this.isSelectedPagamentoItensEstorno) {
        return 'Não é possível conciliar estorno com itens não conciliados.'
      } else if (this.isGlosaMaiorFaturado) {
        return 'Não é possível conciliar itens com glosa maior que o valor faturado.'
      } else {
        return `Lote de pagamento apresenta status ${pagamentoLoteStatusLabels[this.pagamentoLoteStatus]}. Não é possível alterar a conciliação.`
      }
    },
    selectedPagamentoItemIds () {
      return Object.keys(this.selectedPagamentoItens)
    },
    selectedFaturamentoItemIds () {
      return Object.keys(this.selectedFaturamentoItens)
    },
    totalInformadoPagamento () {
      return this.selectedPagamentoItemIds.reduce((total, id) => total + this.selectedPagamentoItens[id].valorInformado, 0)
    },
    totalPagoPagamento () {
      return this.selectedPagamentoItemIds.reduce((total, id) => total + this.selectedPagamentoItens[id].valorPago, 0)
    },
    totalGlosadoPagamento () {
      return this.selectedPagamentoItemIds.reduce((total, id) => total + this.selectedPagamentoItens[id].valorGlosado, 0)
    },
    totalInformadoFaturamento () {
      return this.selectedFaturamentoItemIds.reduce((total, id) => total + this.selectedFaturamentoItens[id].valor, 0)
    },
    totalPagoFaturamento () {
      return this.selectedFaturamentoItemIds.reduce(
        (total, id) => total + this.selectedFaturamentoItens[id].conciliacaoItens?.reduce(
          (total, conciliacaoItem) => total + conciliacaoItem.valorPago, 0), 0)
    },
    totalGlosadoFaturamento () {
      return this.selectedFaturamentoItemIds.reduce(
        (total, id) => total + this.selectedFaturamentoItens[id].conciliacaoItens?.reduce(
          (total, conciliacaoItem) => total + conciliacaoItem.valorGlosado, 0), 0)
    },
    conciliacaoItensToCreate () {
      return this.selectedPagamentoItemIds.map(pagamentoItemId => (
        this.selectedFaturamentoItemIds.map(faturamentoItemId => ({ pagamentoItemId, faturamentoItemId }))
      )).flat()
    },
    totalSaldoFaturamento () {
      return this.selectedFaturamentoItemIds.reduce((total, id) => total + this.selectedFaturamentoItens[id].saldo, 0)
    },
    selectedPagamentoItensRecursoNeedsMotivoGlosa () {
      const pagamentoItens = Object.values(this.selectedPagamentoItens)

      return pagamentoItens.filter(item =>
        item.tipoRegistro === 'recurso' &&
        item.valorGlosado > 0 &&
        (item.motivoGlosa === null || item.motivoGlosa === '' || item.motivoGlosa === undefined)).length > 0
    },
    hasAnySelectedFaturamentoConciliacaoWithSomeMotivoGlosa () {
      const faturamentoItens = Object.values(this.selectedFaturamentoItens)

      return faturamentoItens.some(item =>
        item.conciliacaoItens?.some(conciliacao =>
          conciliacao.motivoGlosa === null || conciliacao.motivoGlosa === '' || conciliacao.motivoGlosa === undefined))
    },
    tissMotivosGlosa () {
      return this.getTissMotivosGlosaPage?.data.map(motivoGlosa => (
        {
          id: motivoGlosa.id,
          text: motivoGlosa.termo
        }
      )) || []
    }
  },
  methods: {
    async createConciliacaoItens (motivoGlosa) {
      const data = {
        itens: this.conciliacaoItensToCreate,
        motivoGlosaManual: motivoGlosa
      }

      try {
        await conciliacaoClient.conciliacaoItens.createConciliacaoItens(data)
        this.$store.dispatch('conciliacao/conciliacaoItensCreated')
      } catch (axiosError) {
        if(axiosError.response.status === 422) {
          console.log(axiosError.response.data)
          this.alertTitle = 'Não foi possível conciliar os itens';
          this.alertDescription = 'Ocorreram os seguintes erros de validação:';
          this.alertErrors = [axiosError.response.data.detail];
          this.alertIsOpen = true;
        } else {
          window.alert('Erro ao conciliar itens')
        }
      }
    },
    openModal () {
      const valorInformadoDivergente = this.selectedPagamentoItensCount === 1 &&
        this.selectedFaturamentoItensCount >= 1 &&
        (!this.isSelectedPagamentoItensRecurso && this.totalInformadoPagamento !== this.totalInformadoFaturamento)
      const recursoSemMotivoGlosa = this.selectedPagamentoItensRecursoNeedsMotivoGlosa &&
        !this.hasAnySelectedFaturamentoConciliacaoWithSomeMotivoGlosa

      let paramModal = {
        type: 'warning',
      }

      if (valorInformadoDivergente) {
        paramModal.title = 'Deseja realmente conciliar?'
        paramModal.message = `Valor informado da conta (${formatCurrency(this.totalInformadoPagamento)}) não confere com o valor informado do demonstrativo (${formatCurrency(this.totalInformadoFaturamento)})!`
        paramModal.callback = () => {
    this.createConciliacaoItens();
  }
      }

      if (recursoSemMotivoGlosa) {
        paramModal.title = 'Incluir motivo de glosa para conciliar'
        paramModal.selectMenu = {
          label: "Adicione o motivo de glosa",
          show: true,
          items: this.tissMotivosGlosa
        }
        paramModal.maxLengthItem = 55
        paramModal.callback = null
        paramModal.selectMenuForm = (motivoGlosa) => {
          this.createConciliacaoItens(motivoGlosa.id)
        }
      }

      paramModal.btCancel = {
        name: 'Cancelar',
        show: true
      }
      paramModal.btConfirm = {
        name: 'Conciliar',
        show: true,
        color: 'primary'
      }
      this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
    },
    async handleConciliarClick () {
      if (this.isLoading) return;
      this.isLoading = true;
      try{
      if (
          (this.selectedPagamentoItensCount === 1 &&
          this.selectedFaturamentoItensCount >= 1 &&
          (!this.isSelectedPagamentoItensRecurso && this.totalInformadoPagamento !== this.totalInformadoFaturamento)) ||
          (this.selectedPagamentoItensRecursoNeedsMotivoGlosa &&
          !this.hasAnySelectedFaturamentoConciliacaoWithSomeMotivoGlosa)
      ) {
        this.openModal()
      } else {
        await this.createConciliacaoItens()
      }
    }
    finally
    {
      this.isLoading =false;
      }
    }
  },
  filters: {
    formatCurrency (value) {
      return formatCurrency(value)
    },
    pluralizePagamento (count) {
      if (count === 0) {
        return 'Nenhum item de pagamento selecionado'
      } else if (count === 1) {
        return '1 item de pagamento selecionado'
      } else {
        return `${count} itens de pagamento selecionados`
      }
    },
    pluralizeFaturamento (count) {
      if (count === 0) {
        return 'Nenhum item de faturamento selecionado'
      } else if (count === 1) {
        return '1 item de faturamento selecionado'
      } else {
        return `${count} itens de faturamento selecionados`
      }
    }
  },
  asyncComputed: {
    getTissMotivosGlosaPage: {
      get () {
        return conciliacaoClient.pagamentoItem.getTissMotivosGlosaPage({
          pageSize: 1000
        })
      }
    },
  }
}
</script>
